import { Injectable, signal } from '@angular/core';

const STORAGE_KEY = 'active_research_id';

/**
 * Holds the active research id for the current user.
 *
 * Deliberately HTTP-free so the request interceptor can read it without
 * creating a dependency cycle (the interceptor attaches `X-Research-Id`).
 */
@Injectable({ providedIn: 'root' })
export class ResearchSelectionService {
  readonly activeId = signal<string | null>(this.readStored());

  set(id: string | null): void {
    this.activeId.set(id);
    try {
      if (id) localStorage.setItem(STORAGE_KEY, id);
      else localStorage.removeItem(STORAGE_KEY);
    } catch {
      /* storage unavailable — in-memory only */
    }
  }

  private readStored(): string | null {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch {
      return null;
    }
  }
}
